// extracted by mini-css-extract-plugin
module.exports = {"informations":"Informations_informations__hlj_0","placeholder":"Informations_placeholder__VL_aT"};